<template>
  <div class="p-8 w-full min-h-screen">
    <uploader :options="options" @file-success="handleSuccess()" @file-error="handleError()" class="uploader-example">
      <uploader-unsupport></uploader-unsupport>
      <uploader-drop>
        <p>Drop files here to upload or</p>
        <uploader-btn :attrs="attrs">select files</uploader-btn>
      </uploader-drop>
      <uploader-list></uploader-list>
    </uploader>
    <div class="uploader-example px-4">
      <el-progress :text-inside="true" :stroke-width="20" :percentage="percentage" status="success"></el-progress>
    </div>
    <ProductsUploadsDetail class="uploader-example px-4" />
  </div>
</template>

<script>
import connection from '../helper/socket';
import ProductsUploadsDetail from './_includes/ProductsUploadsDetail';
/**
 * https://forum.adonisjs.com/t/how-to-adonis-websocket-server-client-with-vue-cli-3/3615
 * https://itnext.io/setting-up-adonisjs-websockets-with-react-app-demo-27bb0bb7500f
 */
export default {
  name: 'CSVUpload',
  data() {
    return {
      options: {
        target: `${process.env.VUE_APP_FILE_UPLOAD_URL}?token=${this.$store.state.AuthStore.token.token}`,
        testChunks: false,
        chunkSize: 1000000000,
      },
      attrs: {
        accept: '.csv',
      },
      percentage: 0,
      uploadStatus: false,
    };
  },
  components: {
    ProductsUploadsDetail,
  },
  computed: {
    socketsMessages() {
      return this.$store.state.InventoryModule.Products.socketMessages;
    },
  },
  beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    if ((this.percentage < 0 && this.percentage > 100) && this.uploadStatus) {
      this.$confirm('You cannot leave this page until the upload is done', 'Danger', {
        type: 'danger',
        center: true,
      });
    } else {
      next();
    }
  },
  methods: {
    handleSuccess() {
      this.$notify.success({
        title: 'Success',
        message: 'File Upload was Successful',
      });
    },
    handleError() {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    },
    format(percentage) {
      return percentage === 100 ? 'Done !!' : `${percentage}%`;
    },
    messageHandler() {
      this.uploadStatus = true;
      this.$store.commit('InventoryModule/Products/setProperty', { property: 'socketMessages', payload: [] });
      const self = this;
      return function (message) {
        if (message.data.length > 0) {
          self.percentage = parseInt(message.data);

          if (message.data === 100) {
            self.uploadStatus = false;
            this.$store.dispatch('InventoryModule/Products/fetchCsvUploads');
          }
        }
      };
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    const connect = connection.connect();
    connect.subscribe(`upload:${this.$store.state.AuthStore.user.id}`, this.messageHandler());

    await this.$store.dispatch('InventoryModule/Products/fetchCsvUploads');
  },
};
</script>

<style scoped lang="scss">
  .uploader-example {
    width: 880px;
    padding: 15px;
    margin: 40px auto 0;
    font-size: 12px;
    border: 2px solid #efefef;
    border-radius: 4px;

    .el-progress-bar__outer {
      border-radius: 4px !important;
    }
  }
  .uploader-example .uploader-btn {
    margin-right: 4px;
  }
  .uploader-example .uploader-list {
    max-height: 440px;
    overflow: auto;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .messages {
    background-color: #f5f5f5;
    width: 880px;
    margin: 40px auto 0;
    font-size: 12px;
    border: 2px solid #efefef;
    border-radius: 4px;

    ul {
      max-height: 300px;
      overflow: scroll;
    }

  }

  .header {
    width: 880px;
    margin: 40px auto 0;
  }

  .progress {
    height: 60px;
    background-color: #f5f5f5;
    width: 300px;
    border-radius: 4px;
    padding-top: 20px;
    position: absolute;
    bottom: 10px;
    right: 57px;
  }
</style>
